import { LOG_LEVELS } from "../constants/LogLevels"
import { sendToLogServer } from "../core/service/BusinessLogicService"
import { digitalJourneyApigateway } from "../intances/apigateway"

const API_URL_GET_BIC_NL = `middle-business-service/api/v1/code-bic/NL`

/**
 * getBicNlList() récupère la liste des BIC néerlandais depuis le backend.
 * Retourne un tableau d'objets, ex. [{ code: "ABNA", bic: "ABNANL2A" }, ...]
 * @param tunnelData - data of journey
 */
export function getBicNlList(tunnelData) {
  return digitalJourneyApigateway(tunnelData)
    .get(API_URL_GET_BIC_NL)
    .then((response) => response.data)
    .catch((error) => {
      sendToLogServer(
        LOG_LEVELS.ERROR,
        `An error occured when retrieving NL BIC list, error message => ${error.message}`
      )
      throw error
    })
}
